import React, { useEffect } from "react";
import styles from "./WinModal.module.scss";
import { Button } from "../../shared";
import { WinModalProps } from "./types";
import Modal from "react-modal";
import { X } from "react-bootstrap-icons";

const WinModal: React.FC<WinModalProps> = ({ isOpen, setOpen }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  // Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
  // useEffect(() => {
  //   const body = document.querySelector("body");
  //   Modal.setAppElement(body);
  // });

  function openModal() {
    setOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    setOpen(false);
  }

  useEffect(() => {
    openModal();
  }, []);

  return (
    <div className={styles.modal}>
      <Modal
        isOpen={isOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        ariaHideApp={false}
      >
        <Button onClick={closeModal} className={styles.modal__close}>
          <X className={styles.modal__close__icon} />
        </Button>
        <div className={styles.modal__content}>You won !!!</div>
      </Modal>
    </div>
  );
};

export default WinModal;
